import styled from 'styled-components';

interface TitleButtonProps {
  title: string;
  onClick: () => void;
  selected?: boolean;
  'data-testid'?: string;
}

const Title = styled.h2<{ selected?: boolean }>`
  color: ${(props) =>
    props.selected
      ? props.theme.atlas.semantic.color.surface.default
      : props.theme.atlas.semantic.color.type.disabled};
  margin: 0;
  font-size: 18px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.headingH3.fontFamily};
  font-weight: 500;
  z-index: 0;
  white-space: nowrap;
  &:hover {
    cursor: ${(props) => (props.selected ? 'auto' : 'pointer')};
  }
`;

export const TitleButton = ({
  title,
  onClick,
  selected,
  ...props
}: TitleButtonProps) => (
  <Title
    onClick={onClick}
    selected={selected}
    data-testid={props['data-testid']}
    {...props}
  >
    {title}
  </Title>
);
